<!-- https://www.iconsdb.com/green-icons/check-mark-2-icon.html -->

<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '350px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top" style="background-color: rgb(255, 255, 255)">
	<!-- 		 	     -->
	<!-- Person Selector -->
	<!-- 			 	 -->
	<div>
		<caass-personselector [AudienceID]="1" [CanSwitchAudience]="true" [ShowAllSchools]="false"></caass-personselector>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div style="padding: 20px; background-color: rgb(235, 235, 235)">
		<!-- Image File Selector Button -->
		<label for="fileSelectImages" class="btn btn-primary" style="margin-left: 0px">Add Photo</label>
		<input
			id="fileSelectImages"
			type="file"
			(change)="onAddPhoto($event)"
			onclick="event.target.value=''"
			style="visibility: hidden; position: absolute"
			accept="image/*"
		/>

		<button class="btn btn-primary" style="margin-left: 5px" (click)="onEditPhoto()">Edit Photo</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onCheckAll()">Check All</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onUnCheckAll()">Uncheck All</button>
		<button class="btn btn-success" style="margin-left: 5px" (click)="onAutoAssign()">Assign Checked</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onUnAssign()">Unassign Checked</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()">Delete Checked</button>
		<button class="btn btn-warning" style="margin-left: 5px" (click)="onManualAssign()">Manual Assign</button>
		<button class="btn btn-info" style="margin-left: 25px" (click)="onTransfer()">&lt; Transfer &gt;</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: rgb(235, 235, 235)" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Images in staging area: {{ ImageStagingQueue.length }}</label
		><br />
		<label>&#9900; Click on item to select.</label><br />
		<label>&#9900; Click on photo to check/uncheck item.</label><br />
		<label>&#9900; Assign Checked will associate using the file name to the student/staff by ID for the current school.</label><br />
		<label>&#9900; Assign Checked will not assign already assigned items.</label><br />
		<label>&#9900; Manual Assign will assign the selected person to only the selected item, even if it is already assigned.</label><br />
		<label>&#9900; Transfer will move into CAASS all assigned photos that are checked.</label><br />
		<label>&#9900; Click on photo in person selector to edit photos that have been transfered to CAASS.</label>
	</div>
</div>

<!-- 				   -->
<!-- Display When Busy -->
<!-- 				   -->
<div style="padding: 20px" [style.display]="isBusy == true ? 'block' : 'none'">
	<img class="busy-img" src="assets/images/loading.gif" />
</div>

<!-- 						-->
<!-- Display When No Photos -->
<!-- 					    -->
<div style="padding: 20px" [style.display]="ImageStagingQueue.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>Image Staging Area Is Empty...</label>
</div>

<!-- 				-->
<!-- Display Photos -->
<!-- 				-->
<div class="flex-container" [style.display]="isBusy == false ? 'flex' : 'none'">
	<div
		*ngFor="let obj of ImageStagingQueue"
		class="flex-container-stamp"
		[ngClass]="{
			'stamp-item-selected': obj.IsSelected == true,
			'stamp-item-unselected': obj.IsSelected == false,
			'flex-container-stamp-assign-auto': obj.IsAutoAssigned == true && obj.PersonID > 0,
			'flex-container-stamp-assign-manual': obj.IsAutoAssigned == false && obj.PersonID > 0,
			'flex-container-stamp-assign-none': obj.PersonID < 1
		}"
	>
		<div class="flex-container-stamp-body" (click)="onSelectItem($event, obj)">
			<img
				[ngClass]="obj.IsChecked == true ? 'stamp-img-check' : 'stamp-img-uncheck'"
				src="assets/images/checked-checkbox-24-white.png"
				(click)="onCheckItem($event, obj)"
			/>

			<div class="stamp-column1-body">
				<img class="stamp-column1-fix-img" [src]="obj.ImageData_Thumb" (click)="onCheckItem($event, obj)" />
			</div>

			<div class="stamp-column2-body">
				<div *ngIf="obj?.PersonID <= 0">
					<div class="stamp-column2-heading">
						<div>
							<label class="stamp-column2-heading-label">File:</label>
						</div>
					</div>

					<div class="stamp-column2-data">
						<div>
							<label class="stamp-column2-data-label">{{ obj.FileName }}</label>
						</div>
					</div>
				</div>

				<div *ngIf="obj?.PersonID > 0">
					<div class="stamp-column2-heading">
						<div>
							<label class="stamp-column2-heading-label">Name:</label>
						</div>
						<div>
							<label class="stamp-column2-heading-label">ID:</label>
						</div>
						<div>
							<label class="stamp-column2-heading-label">Type:</label>
						</div>
						<div>
							<label class="stamp-column2-heading-label">File:</label>
						</div>
					</div>

					<div class="stamp-column2-data">
						<div>
							<label class="stamp-column2-data-label">{{ obj.FullName }}</label>
						</div>
						<div>
							<label class="stamp-column2-data-label">{{ obj.ID }}</label>
						</div>
						<div>
							<label class="stamp-column2-data-label">{{ obj.IsStudent ? "Student" : "Staff" }}</label>
						</div>
						<div>
							<label class="stamp-column2-data-label">{{ obj.FileName }}</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
